import About from '../components/CompanyPage/About.js';
import Services from '../components/CompanyPage/Services.js';
import Contact from '../components/CompanyPage/Contact.js';
import Header from '../components/Secciones/Header.js';
import Footer from '../components/Secciones/Footer.js';

const CompanyPage = () => {
  return (
    <div className="company-page">
      <Header />
      <main>
        <About />
        <Services />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default CompanyPage;
